import useTemplatesManager from "hooks/templates/useTemplatesManager"
import React from "react"
import TemplateCard from "./TemplateCard"
import { Box, Grid, Typography } from "@mui/material"
import { PLANHOPPER_ORG_ID } from "constants/common"
import { useAuthContext } from "context/auth/authContext"
import Loading from "common/Loading"
import i18n from "i18n"

const PlanhopperTemplatesTab = () => {
  const { user } = useAuthContext()
  const { state, duplicateToTemplate, setTabSelected } = useTemplatesManager()

  const templates = (state.templates || []).filter(
    ({ organizationId }) => organizationId === PLANHOPPER_ORG_ID,
  )

  const getTemplateActions = projectId => {
    const organizationId = user?.["custom:organizationId"]
    if (!organizationId) return []

    return [
      {
        key: "duplicate",
        label: i18n.t("templates.actions.duplicate"),
        onClick: () => {
          duplicateToTemplate(projectId, organizationId)
          setTabSelected(0)
        },
      },
    ]
  }

  if (state.loading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          minHeight: "calc(100dvh - 160px)",
        }}
      >
        <Loading />
      </Box>
    )
  }

  return (
    <Grid container spacing={3}>
      {templates.length === 0 ? (
        <Box sx={{ p: 4 }}>
          <Typography variant="body1">{i18n.t("templates.empty")}</Typography>
        </Box>
      ) : (
        templates.map(({ projectId, name, projectImage }) => (
          <Grid item key={projectId} xs={12} sm={6} md={4}>
            <TemplateCard
              title={name}
              imageSrc={projectImage}
              actions={getTemplateActions(projectId)}
            />
          </Grid>
        ))
      )}
    </Grid>
  )
}

PlanhopperTemplatesTab.propTypes = {}

export default PlanhopperTemplatesTab
